
import Navbar from '../components/Navbar/Navbar';
import Accessories from '../sections/Accessories/Accessories';
import Footer from '../sections/Footer/Footer';

const Gallery = () => {
    return (
        <>
            <Navbar />
            <Accessories />
            <Footer />
        </>
    );
};

export default Gallery;